/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, DateRange, Highcharts, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';

  // LOTS of cut+paste from reports/ios_7.js in here.

  // We get all kinds of screwball values from crazy libs here,
  // but there is a lot more signal than noise
  // Versions pulled from https://en.wikipedia.org/wiki/Android_version_history
  var android_versions = [
    [/^2\.3/, `Gingerbread (2.3)`],
    [/^3\./, `Honeycomb (3.0 - 3.2)`],
    [/^4\.0/, `Ice Cream Sandwich (4.0)`],
    [/^4\.[123]/, `Jelly Bean (4.1 - 4.3)`],
    [/^4\.4/, `Kit Kat (4.4)`],
    [/^5\.[01]/, `Lollipop (5.0 - 5.1)`],
    [/^6\./, `Marshmallow (6.0)`],
    [/^7\./, `Nougat (7.0-7.1)`],
    [/^8\./, `Oreo (8.0-8.1)`],
    [/^9\.?/, `Pie (9.0)`], // For some reason Pie there are '9' values, not just '9.*'
    [/^(?!x)x/, `Other`], // Pattern will never match (Match only if the first character is 'x' and is not 'x'
  ];

  var translate_version = function(version) {
    var match = _.find(android_versions, function(v) {
      if (v[0].exec(version)) { return true; }
    });
    return (match ? match[1] : `Other`);
  };

  ns.AndroidOsAdoption = mp.marketing.trends.widgets.TrendReport.extend({
    get_defaults() {
      return {
        date_range: new DateRange(new Date(2013, 1, 5), new Date()),
      };
    },

    get_queries() {
      var unit = this.session.get(`report_unit`);
      var date_range = this.session.get(`date_range`);
      if ((unit === `hour`) && (date_range.days() > 4)) {
        var to = date_range.to();
        var ago = new Date(to);
        ago = ago.add(-4).days();
        date_range = new DateRange(ago, to);
      }

      return {
        base: {
          'query_name': `android_fragmentation`,
          unit,
          'from_date': date_range.from().toString(mp.utility.default_date_format),
          'to_date': date_range.to().toString(mp.utility.default_date_format),
        },
      };
    },

    get_chart_params(query_data) {
      var date_format = `yyyy-MM-dd`;
      if (this.session.get(`report_unit`) === `hour`) {
        date_format = `yyyy-MM-dd HH:mm:ss`;
      }

      var by_version = {};
      var totals = {};
      _.each(android_versions, function(pattern_name) {
        by_version[pattern_name[1]] = {};
      }, this);

      _.each(query_data.base, function(dates_counts, version_number) {
        var version_name = translate_version(version_number);

        _.each(dates_counts, function(count, date) {
          // Skip zero-valued future hours (that come back with hourly queries)
          var moment = Date.parseExact(date, date_format).getTime();
          if (moment < mp.report.globals.utc_now) {
            if (!by_version[version_name][date]) {
              by_version[version_name][date] = 0;
            }
            if (!totals[date]) {
              totals[date] = 0;
            }
            by_version[version_name][date] += count;
            totals[date] += count;
          } // endif date is not in the future
        }, this);
      }, this);

      var color_ix = -1;
      var chart_data = _.map(by_version, function(dates_values, name) {
        color_ix++;
        return {
          name,
          color: mp.charts.nth_color(color_ix),
          data: _.map(dates_values, function(val, date) {
            var unixtime = Date.parseExact(date, date_format).getTime();
            var percent = 0;
            if (totals[date]) {
              percent = (val / totals[date]) * 100;
            }
            return [unixtime, percent];
          }, this).sort(),
        };
      }, this);

      return {
        'chart': {
          'marginBottom': 80,
        },
        'xAxis': {
          'labels': {
            'formatter'() {
              return Highcharts.dateFormat(`%b. %e`, this.value);
            },
          },
          'type': `datetime`,
        },
        'yAxis': {'labels': {'formatter'() { return this.value + `%`; }}},
        'series': chart_data,
        'tooltip': {
          'shared': true,
          'crosshairs': true,
          'backgroundColor': `rgba(255, 255, 255, 1)`,
          'borderWidth': 1,
          'useHTML': false,
          'pointFormat': `<span style="color:{series.color}">{series.name}</span>: <b>{point.y}%</b><br/>`,
          'valueDecimals': 2,
        },
      };
    },

    getDownloadName() {
      return ns.AndroidOsAdoption.nice_name;
    },
  });

  ns.AndroidOsAdoption.slug = `android_os_adoption`;
  ns.AndroidOsAdoption.nice_name = `Android OS adoption`;
  ns.AndroidOsAdoption.description = `How quickly are consumers upgrading their Android OS?`;
  ns.AndroidOsAdoption.chart_type = `line`;
  ns.AndroidOsAdoption.asterisk = `Time/Date in UTC`;
});

}.call(window));